import { TAGS } from 'shared/api';

import { EntityType } from '../model';
import type {
  DeleteDocumentRequestParameters,
  DownloadDocumentRequestParameters,
  GetDocumentsRequestParameters,
  UploadDocumentsRequestParameters,
} from './request-params';

export function getTagByEntityType(entityType: EntityType) {
  switch (entityType) {
    case EntityType.Incident:
      return TAGS.USER_COMMON_CASES;
    case EntityType.KeyOrder:
      return TAGS.KEY_ORDERS;
    case EntityType.Repair:
      return TAGS.USER_SPACE_RENOVATION_REQUESTS;
    case EntityType.CommonCase:
      return TAGS.COOPERATIVE_COMMON_CASES;
    case EntityType.SpaceRenovation:
      return TAGS.COOPERATIVE_SPACE_RENOVATION_REQUESTS;
    case EntityType.CooperativeSpace:
      return TAGS.COOPERATIVE_SPACES;
    case EntityType.Task:
      return TAGS.TASKS;
    case EntityType.MassMessage:
      return TAGS.MASS_MESSAGES;
    default:
      return null;
  }
}

export function getFragmentByEntityType(entityType: EntityType) {
  switch (entityType) {
    case EntityType.Incident:
    case EntityType.KeyOrder:
    case EntityType.Repair:
    case EntityType.CommonCase:
    case EntityType.SpaceRenovation:
      return 'incident';
    case EntityType.Building:
      return 'uds_building';
    case EntityType.Lot:
      return 'uds_lot';
    case EntityType.Space:
    case EntityType.CooperativeSpace:
      return 'uds_space';
    case EntityType.MassMessage:
      return 'uds_communicationmessage';
    case EntityType.Task:
      return 'task';
    default:
      return '';
  }
}

type ShouldSkipOptionsQueryOptions = {
  readonly: boolean;
  entityType: EntityType;
};

export function shouldSkipOptionsQuery({
  entityType,
  readonly,
}: ShouldSkipOptionsQueryOptions) {
  return readonly || entityType === EntityType.User;
}

export function buildGetDocumentsEndpoint(
  params: GetDocumentsRequestParameters
) {
  if (params.entityType === EntityType.User) {
    return `/user/documents`;
  }

  return `/user/cooperatives/${params.cooperativeId}/documents${
    params.cached ? '/cached' : ''
  }/${getFragmentByEntityType(params.entityType)}/${params.entityId}`;
}

export function buildDeleteDocumentEndpoint(
  params: DeleteDocumentRequestParameters
) {
  if (params.entityType === EntityType.User) {
    return `/user/documents`;
  }

  return `/user/cooperatives/${
    params.cooperativeId
  }/documents/${getFragmentByEntityType(params.entityType)}/${params.entityId}`;
}

export function buildDownloadDocumentEndpoint(
  params: DownloadDocumentRequestParameters
) {
  if (params.entityType === EntityType.User) {
    return `/user/documents/download`;
  }

  return `/user/cooperatives/${
    params.cooperativeId
  }/documents/${getFragmentByEntityType(params.entityType)}/${
    params.entityId
  }/download`;
}

export function buildUploadDocumentEndpoint(
  params: UploadDocumentsRequestParameters
) {
  if (params.entityType === EntityType.User) {
    return `/user/documents`;
  }

  return `/user/cooperatives/${
    params.cooperativeId
  }/documents/${getFragmentByEntityType(params.entityType)}/${params.entityId}`;
}
